const CallerTextStyle = `
  padding: 15px 0 20px;
  text-align: center;
`;

export default CallerTextStyle;
